import { FitTextModule, ButtonModule, FormFieldModule} from '@shared/components/games';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, JsonPipe } from '@angular/common';
import { ProofreadingTestsControllerComponent } from './proofreading-tests-controller/proofreading-tests-controller.component';
import { ProofreadingTestsSettingsComponent } from './proofreading-tests-settings/proofreading-tests-settings.component';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ProofreadingTestsCorrectAnswerPreviewComponent } from './proofreading-tests-preview/proofreading-tests-answer-preview/proofreading-tests-answer-preview.component';
import { ProofreadingTestsExamplePreviewComponent } from './proofreading-tests-preview/proofreading-tests-example-preview/proofreading-tests-example-preview.component';
import { ProofreadingTestsParametersPreviewComponent } from './proofreading-tests-preview/proofreading-tests-parameters-preview/proofreading-tests-parameters-preview.component';
import { ProofreadingTestsUserAnswerPreviewComponent } from './proofreading-tests-preview/proofreading-tests-user-answer-preview/proofreading-tests-user-answer-preview.component';
import { AlphabetPickerModule } from '@shared/components/games/alphabet-picker/alphabet-picker.module';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';

@NgModule({
  declarations: [
    ProofreadingTestsControllerComponent,
    ProofreadingTestsSettingsComponent,
    ProofreadingTestsCorrectAnswerPreviewComponent,
    ProofreadingTestsExamplePreviewComponent,
    ProofreadingTestsParametersPreviewComponent,
    ProofreadingTestsUserAnswerPreviewComponent,
  ],
  exports: [
    ProofreadingTestsControllerComponent,
    ProofreadingTestsSettingsComponent,
    ProofreadingTestsCorrectAnswerPreviewComponent,
    ProofreadingTestsExamplePreviewComponent,
    ProofreadingTestsParametersPreviewComponent,
    ProofreadingTestsUserAnswerPreviewComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    FitTextModule,
    AlphabetPickerModule,
    JsonPipe,
    GamesSharedModule,
    FormFieldModule,
  ],
})
export class ProofreadingTestsModule {}
